<template>
  <div>
    <div v-if="bgLayout === 'center'" class="center-login-container"
      :style="{ 'background-image': `url(${settingData.bgImage})` }">
      <!-- 蓝色风格一 -->
      <div class="logo"><img src="../../assets/images/logo1.png" /></div>
      <div class="center-login-content">
        <section class="center-login-box" :style="{ 'border-color': settingData.inputBorderColor }">
          <p class="center-login-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.tysfglpt') }}</p>
          <p class="center-login-scan" v-if="judgeNextwork()">
            <svg class="icon" aria-hidden="true" v-show="loginTypeShow"
              @click="loginTypeShow = !loginTypeShow, loginShow = true, doShowDdQRCode()"
              :style="{ 'color': settingData.buttonColor }">
              <use xlink:href="#icon-mimadenglu1"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-show="!loginTypeShow"
              @click="loginTypeShow = !loginTypeShow, loginShow = true, updatePasswordShow = false, mobileShow = false"
              :style="{ 'color': settingData.buttonColor }">
              <use xlink:href="#icon-erweima1"></use>
            </svg>
          </p>
          <section v-show="loginShow">
            <!-- <div class="center-login-tab" :style="{ 'color': settingData.fontColor }">
          </div> -->

            <section class="center-login-form center-login-form-align" v-show="!loginTypeShow">
              <section class="center-login-align">
                <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
                  <span class="input-icon">
                    <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
                      <use xlink:href="#icon-kejiyonghu"></use>
                    </svg>
                  </span>
                  <input v-model="loginFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')"
                    type="text" :style="{ 'color': settingData.fontColor }" />
                </div>
                <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
                  <span class="input-icon">
                    <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
                      <use xlink:href="#icon-kejimima"></use>
                    </svg>
                  </span>
                  <Input v-model="loginFormValidate.userPassword" :border="false" class="input-self"
                    :placeholder="$t('loginPage.mm')" type="password" password
                    :style="{ 'color': settingData.fontColor }" />
                </div>
                <div class="forgetPwd" :style="{ 'color': settingData.fontColor }">
                  <div class="item" @click="languagesModalShow = !languagesModalShow, doGetLanguages()">
                    {{ $t('homePage.xtyy') }}
                  </div>
                  <div class="item">
                    <p class="forget-password" @click="handleFindPassword" :style="{ 'color': settingData.fontColor }">
                      {{ $t('loginPage.wjmm') }}</p>
                  </div>
                </div>
                <div class="center-login-range">
                  <!-- <div v-if="judgeNextwork()" class="special-button" :class="rangeStatus ? 'success' : ''" :style="{ 'color': settingData.fontColor, 'background-color': rangeStatus ? settingData.buttonColor : settingData.inputBorderColor }">
                  <span class="special-slide-block" :style="{ 'background-color': settingData.buttonColor }"></span>
                  <span @mousedown.self="rangeMove" @touchstart.self="rangeMoveMobile" class="special-button-block" :style="{ 'background-color': settingData.slideButtonColor }">
                  </span>
                  <span class="special-slide-text">{{ rangeStatus ? $t('loginPage.yzcg') : $t('loginPage.xyhddl') }}</span>
                </div> -->
                  <drag-verify v-if="judgeNextwork()" style="margin-bottom: 20px; width: 100%;" ref="dragVerifyRef"
                    :height="40" :isPassing.sync="verifyPass" :text="$t('loginPage.xyhddl')"
                    :successText="$t('loginPage.yzcg')" :background="settingData.buttonColor"
                    :handlerBg="settingData.slideButtonColor" handlerIcon="ivu-icon ivu-icon-ios-arrow-forward"
                    successIcon="ivu-icon ivu-icon-ios-checkmark" @handlerMove="verifyParams"
                    @passcallback="rangeMove2">
                  </drag-verify>
                  <div v-else @click="doClickButton" class="special-button" :class="rangeStatus ? 'success' : ''"
                    :style="{ 'color': settingData.fontColor, 'background-color': settingData.buttonColor, 'cursor': 'pointer' }">
                    <span class="special-slide-text">登 录</span>
                  </div>
                </div>
              </section>
            </section>

            <section class="center-login-form" v-show="loginTypeShow">
              <div class="center-login-qrcode">
                <div id="QRCode" v-show="isScanActive === 'wx'" style="width:290px;height:315px;overflow: hidden;">
                </div>
                <div id="QRCodedd" v-show="isScanActive === 'dd'"></div>
              </div>
              <!-- <p class="qrcode-type">
                <span :active="isScanActive === 'dd'" @click="handleScan('dd')" :style="{ 'color': isScanActive === 'dd' ? settingData.fontColor : '#666' }">{{
                  $t('loginPage.ddsm') }}</span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <span :active="isScanActive === 'wx'" @click="handleScan('wx')" :style="{ 'color': isScanActive === 'wx' ? settingData.fontColor : '#666' }">{{
                  $t('loginPage.qywxsm') }}</span>
              </p> -->
            </section>
          </section>

          <update-password v-show="updatePasswordShow" :forgetData="forgetData" :updateType="updateType"
            :userInfo="userInfo" @on-back="onBack" @on-success="onSuccessUpdate"></update-password>

          <mobile-verify v-show="mobileShow" :mobileList="mobileList" :forgetData="forgetData" :userInfo="userInfo"
            :loginFormValidate="loginFormValidate" :type="mobileShowType" @on-back="onBack" @on-update-pwd="onUpdatePwd"
            @on-forget-password="onForgetpwd"></mobile-verify>
        </section>
        <div class="center-login-link" @click="doJumpExternalLinks" :style="{ 'color': settingData.fontColor }">
          &gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll')
          }}&nbsp;&lt;&lt;&lt;</div>
        <footer class="center-login-footer">© 2020 {{ $t('loginPage.bq') }} ICP</footer>
      </div>
    </div>
    <!-- 右边风格二 -->
    <div v-else class="right-login-container2" :style="{ 'background-image': `url(${settingData.bgImage})` }">
      <div class="logo"><img src="../../assets/images/logo1.png" /></div>
      <div class="right-login-content">
        <div class="right-login-content-blur"></div>
        <section :class="{ 'right-login-box': true, 'right-login-box-padding': loginTypeShow }"
          :style="{ 'background-color': settingData.loginBgColor, 'border-color': settingData.inputBorderColor }">
          <p class="right-login-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.tysfglpt') }}</p>
          <p class="right-login-scan" v-if="judgeNextwork()">
            <svg class="icon" aria-hidden="true" v-show="loginTypeShow"
              @click="loginTypeShow = !loginTypeShow, doShowDdQRCode()" :style="{ 'color': settingData.buttonColor }">
              <use xlink:href="#icon-mimadenglu"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-show="!loginTypeShow"
              @click="loginTypeShow = !loginTypeShow, updatePasswordShow = false, mobileShow = false"
              :style="{ 'color': settingData.buttonColor }">
              <use xlink:href="#icon-erweima"></use>
            </svg>
            <span class="scan-tag" :style="{ 'background-color': settingData.loginBgColor }"></span>
          </p>
          <!-- 账号密码登录 -->
          <section class="right-login-form" v-show="!loginTypeShow && !mobileShow && !updatePasswordShow">
            <p class="right-login-form-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.zhdl') }}</p>
            <div class="right-login-form-input"
              :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
              <span class="input-icon">
                <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
                  <use xlink:href="#icon-yonghu"></use>
                </svg>
              </span>
              <input v-model="loginFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')"
                type="text" :style="{ 'color': settingData.fontColor }" />
            </div>
            <div class="right-login-form-input"
              :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
              <span class="input-icon">
                <Icon size="20" type="ios-lock-outline" :style="{ 'color': settingData.inputBorderColor }" />
              </span>
              <Input v-model="loginFormValidate.userPassword" :border="false" class="input-self"
                :placeholder="$t('loginPage.mm')" type="password" password
                :style="{ 'color': settingData.fontColor }" />
            </div>
            <div class="forgetPwd" :style="{ 'color': settingData.fontColor }">
              <div class="item" @click="languagesModalShow = !languagesModalShow, doGetLanguages()">
                {{ $t('homePage.xtyy') }}
              </div>
              <div class="item">
                <p class="forget-password" @click="handleFindPassword" :style="{ 'color': settingData.fontColor }">{{
                  $t('loginPage.wjmm') }}</p>
              </div>
            </div>
            <div class="right-login-range">
              <!-- <div v-if="judgeNextwork()" class="special-button" :class="rangeStatus ? 'success' : ''" :style="{ 'background-color': rangeStatus ? settingData.buttonColor : settingData.inputBorderColor }">
              <span class="special-slide-block" :style="{ 'background-color': settingData.buttonColor }"></span>
              <span @mousedown.self="rangeMove" @touchstart.self="rangeMoveMobile" class="special-button-block" :style="{ 'background-color': settingData.slideButtonColor }">
              </span>
              <span class="special-slide-text">{{ rangeStatus ? $t('loginPage.yzcg') : $t('loginPage.xyhddl') }}</span>
            </div> -->
              <drag-verify v-if="judgeNextwork()" style="margin-bottom: 20px; width: 100%;" ref="dragVerifyRef"
                :height="40" :isPassing.sync="verifyPass" :text="$t('loginPage.xyhddl')"
                :successText="$t('loginPage.yzcg')" :background="settingData.buttonColor"
                :handlerBg="settingData.slideButtonColor" handlerIcon="ivu-icon ivu-icon-ios-arrow-forward"
                successIcon="ivu-icon ivu-icon-ios-checkmark" @handlerMove="verifyParams" @passcallback="rangeMove2">
              </drag-verify>
              <div v-else @click="doClickButton" class="special-button" :class="rangeStatus ? 'success' : ''"
                :style="{ 'background-color': settingData.buttonColor, 'cursor': 'pointer' }">
                <span class="special-slide-text">登 录</span>
              </div>
            </div>
          </section>

          <section class="right-login-form" v-show="loginTypeShow">
            <!-- <p class="right-login-form-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.smdl') }}</p> -->
            <div class="right-login-qrcode">
              <div id="QRCode" v-show="isScanActive === 'wx'" style="width:290px;height:315px;overflow: hidden;"></div>
              <div id="QRCodedd" v-show="isScanActive === 'dd'"></div>
            </div>
            <!-- <p class="qrcode-type">
              <span :active="isScanActive === 'dd'" @click="handleScan('dd')" :style="{ 'color': isScanActive === 'dd' ? settingData.fontColor : '#666' }">{{
                $t('loginPage.ddsm') }}</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span :active="isScanActive === 'wx'" @click="handleScan('wx')" :style="{ 'color': isScanActive === 'wx' ? settingData.fontColor : '#666' }">{{
                $t('loginPage.qywxsm') }}</span>
            </p> -->
          </section>

          <update-password v-show="updatePasswordShow" :forgetData="forgetData" :updateType="updateType"
            :userInfo="userInfo" @on-back="onBack" @on-success="onSuccessUpdate"></update-password>

          <mobile-verify v-show="mobileShow" :mobileList="mobileList" :forgetData="forgetData" :userInfo="userInfo"
            :loginFormValidate="loginFormValidate" :type="mobileShowType" @on-back="onBack" @on-update-pwd="onUpdatePwd"
            @on-forget-password="onForgetpwd"></mobile-verify>
        </section>
        <div class="right-login-link" @click="doJumpExternalLinks" :style="{ 'color': settingData.fontColor }">
          &gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll')
          }}&nbsp;&lt;&lt;&lt;</div>
        <footer class="right-login-footer">© 2020 {{ $t('loginPage.bq') }} ICP</footer>
      </div>
    </div>
    <!-- 切换语言 -->
    <Modal class-name="modal-container" v-model="languagesModalShow" width="50%">
      <p slot="header" class="modal-title">{{ $t('homePage.xtyyxz') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in languageList" :key="item.id" @click="handleSetDefaultLanguage(item)">
          <p class="checked" v-show="item.isDefault === 1">
            <Icon class="icon" type="md-checkmark" />
          </p>
          <template v-if="item.name.includes('中文简体')">
            <img src="../../assets/images/lan1.png" />
            <p class="name" :active="item.isDefault === 1">{{ $t('homePage.zwjt') }}</p>
          </template>
          <template v-else-if="item.name.includes('中文繁体')">
            <img src="../../assets/images/lan2.png" />
            <p class="name" :active="item.isDefault === 1">{{ $t('homePage.zwft') }}</p>
          </template>
          <template v-else-if="['英文', 'english', 'English'].includes(item.name)">
            <img src="../../assets/images/lan3.png" />
            <p class="name" :active="item.isDefault === 1">{{ $t('homePage.yw') }}</p>
          </template>
          <template v-else-if="['泰语'].includes(item.name)">
            <img src="../../assets/images/lan4.png" />
            <p class="name" :active="item.isDefault === 1">{{ $t('homePage.ty') }}</p>
          </template>
          <template v-else-if="['韩语'].includes(item.name)">
            <img src="../../assets/images/lan5.png" />
            <p class="name" :active="item.isDefault === 1">{{ $t('homePage.hy') }}</p>
          </template>
          <template v-else>
            <img src="../../assets/images/logo1.png" />
            <p class="name" :active="item.isDefault === 1">{{ item.name }}</p>
          </template>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="languagesModalShow = false, doGetLanguages()">{{ $t('qx')
          }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetDefaultLanguage">{{ $t('qr') }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import updatePassword from './password'
import mobileVerify from './mobile'
import { session, cookie } from '@/libs/location'
import dragVerify from '@/components/drag-verify'
export default {
  components: {
    updatePassword,
    mobileVerify,
    dragVerify
  },
  data() {
    return {
      languagesModalShow: false,
      languageList: [],
      language: {
        languageChar: '',
        languageSign: ''
      },
      updateType: '',
      bgLayout: 'center',
      loginTypeShow: false,
      updatePasswordShow: false,
      loginShow: true,
      mobileShow: false,
      mobileShowType: 'mobile',
      disX: 0,
      rangeStatus: false,
      isScanActive: 'dd',
      loginFormValidate: {
        userName: '',
        userPassword: ''
      },
      mobileList: [],
      forgetData: {},
      userInfo: {},
      verifyPass: false
    }
  },
  computed: {
    settingData() {
      return this.$store.state.settingData
    }
  },
  watch: {
    isScanActive: {
      handler(val) {
        this.$nextTick(() => {
          this.handleScan(val)
        })
      },
      immediate: true
    }
  },
  created() {
    this.bgLayout = this.$store.state.settingData.bgLayout
    if (JSON.parse(session.getItem('language'))) {
      this.$i18n.locale = JSON.parse(session.getItem('language')).languageSign
    }
    console.log(this.$store.state.settingData, 'settingData')
  },
  methods: {
    // 获取语言列表
    doGetLanguages() {
      this.$request.post('/sso/language/findList').then(res => {
        const { code, data } = res.data

        if (JSON.parse(session.getItem('language'))) {
          this.languageList = data.map(n => {
            if (n.keySign === JSON.parse(session.getItem('language')).languageSign) {
              n.isDefault = 1
            } else {
              n.isDefault = 0
            }
            return n
          })
        } else {
          this.languageList = data
        }
        console.log(JSON.parse(session.getItem('language')))
      })
    },
    // 语言选择效果
    handleSetDefaultLanguage(item) {
      console.log(item)
      this.languageList.forEach(n => {
        if (n.keySign === item.keySign) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
      this.language = {
        languageChar: item.languageChar,
        languageSign: item.keySign
      }
    },
    // 设置默认语言列表
    doSetDefaultLanguage() {
      this.languagesModalShow = false
      // 切换语言
      let _data = this.languageList.find(n => n.isDefault === 1)
      this.$i18n.locale = _data.keySign
      console.log(this.language)
      session.setItem('language', JSON.stringify(this.language))
    },
    judgeNextwork() {
      if (!window.document.location.origin.includes('hello.')) {
        return true
      } else {
        return false
      }
    },
    // 打开wx二维码登录
    doShowQRCode() {
      //  encodeURIComponent(`http://www.baidu.com`)
      let _baseUrl = this.$baseUrl.replace('.yihchina.com', '.yihchina.net')
      let cssurl = encodeURIComponent('https://hello.yihchina.net/image/wxewm.css')
      let a = window.WwLogin({
        id: 'QRCode',
        appid: this.$appid,
        agentid: this.$agentid,
        redirect_uri: encodeURIComponent(`${_baseUrl}/sso/wechat/authorize`),
        state: '',
        href: cssurl
      })
      console.log('微信扫码登录', a)
    },
    initDingLogin() {
      // 规范化 baseUrl，移除末尾斜杠，确保 URL 格式正确
      let _baseUrl = (this.$baseUrl || window.document.location.origin).replace(/\/+$/, '')
      // 如果 baseUrl 为空或格式不正确，使用当前页面的 origin
      if (!_baseUrl || !_baseUrl.startsWith('http')) {
        _baseUrl = window.document.location.origin
      }

      // 构建完整的 redirect_uri，确保格式正确
      const redirectUri = `${_baseUrl}/sso/dingDing/getUserForAutoLogin`

      // if (window.DTFrameLogin) {
      const corpId = "ding4adf755c2ec445dca1320dcb25e91351";
      const clientId = "dinghspqbszng20ue52t";
      console.log('钉钉登录 redirect_uri:', redirectUri);
      window.DTFrameLogin(
        {
          id: 'QRCodedd',
          theme: 'dark',
          width: 270,
          height: this.bgLayout === 'center' ? 310 : 290,
        },
        {
          // 注意：redirect_uri 需为完整URL，扫码后钉钉会带code跳转到这里
          redirect_uri: encodeURIComponent(redirectUri),
          // redirect_uri: encodeURIComponent(`http://localhost:8080/sso/dingDing/getUserForAutoLogin`),
          client_id: clientId,
          scope: 'snsapi_login',
          response_type: 'code',
          state: '1',
          prompt: 'consent',
          // corpId: corpId,
        },
        (loginResult) => {
          console.log(loginResult);
          const { redirectUrl, authCode, state } = loginResult;
          // 这里可以直接进行重定向
          // window.location.href = redirectUrl.replace('http://localhost:8080','http://192.168.0.156:8900');
          window.location.href = redirectUrl
        },
        (errorMsg) => {
          // 这里一般需要展示登录失败的具体原因
          if (errorMsg) {
            console.error('钉钉登录错误:', errorMsg);
            // 使用更友好的错误提示，避免在个别浏览器中弹出原生 alert
            if (this.$message) {
              this.$message.error(`登录失败: ${errorMsg}`);
            } else {
              alert(`Login Error: ${errorMsg}`);
            }
          }
        },
      );
      // } else {
      //     setTimeout(initDingLogin, 100);
      // }
    },
    // 打开dd二维码登录
    doShowDdQRCode() {
      this.initDingLogin()
      return
      // //  encodeURIComponent(`http://www.baidu.com`)
      // let _baseUrl = this.$baseUrl.replace('.yihchina.com', '.yihchina.net')
      // let _gotoUrl = encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoaffcv1abgqhnnrelx&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}sso/dingDing/getUserForAutoLogin`)
      // let a
      // if (this.bgLayout === 'center') {
      //   a = window.DDLogin({
      //     id: 'QRCodedd',
      //     goto: _gotoUrl,
      //     style: 'border:none;background-color:#FFFFFF;',
      //     width: '270',
      //     height: '310'
      //   })
      // } else {
      //   a = window.DDLogin({
      //     id: 'QRCodedd',
      //     goto: _gotoUrl,
      //     style: 'border:none;background-color:#FFFFFF;',
      //     width: '270',
      //     height: '290'
      //   })
      // }
      // let handleMessage = function (event) {
      //   let origin = event.origin
      //   // 判断是否来自ddLogin扫码事件。
      //   if (origin === 'https://login.dingtalk.com') {
      //     let loginTmpCode = event.data
      //     // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
      //     window.location = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoa8cqdj2mkis3xlp0n&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}sso/dingDing/getUserForAutoLogin&loginTmpCode=${loginTmpCode}`
      //   }
      // }
      // if (typeof window.addEventListener !== 'undefined') {
      //   window.addEventListener('message', handleMessage, false)
      // } else if (typeof window.attachEvent !== 'undefined') {
      //   window.attachEvent('onmessage', handleMessage)
      // }
      // console.log('dd扫码登录', a)
    },
    doJumpExternalLinks() {
      // this.showLinks = !this.showLinks
      let newpage = this.$router.resolve({ name: 'link' })
      window.open(newpage.href, 'ssoexl')
    },
    handleTurnColorRgb(colorStr) {
      // 16进制颜色值的正则
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 把颜色值变成小写
      let color = colorStr.toLowerCase()
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = colorNew
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = []
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return colorChange
      } else {
        return color
      }
    },
    verifyParams(e) {
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
        // this.verifyPass = true
        this.$refs.dragVerifyRef.reset()
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
        // this.verifyPass = true
        this.$refs.dragVerifyRef.reset()
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
        // this.verifyPass = true
        this.$refs.dragVerifyRef.reset()
      } else {

      }
    },
    rangeMove2() {
      this.rangeStatus = true
      if (this.status) {
        this.$parent[this.status] = true
      }
      // 执行成功的函数
      this.doVerify()
    },
    // 滑块移动
    rangeMove(e) {
      console.log('pc')
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
      } else {
        let ele = e.target
        let startX = e.clientX
        let eleWidth = ele.offsetWidth
        let parentWidth = ele.parentElement.offsetWidth

        console.log('startX', startX)
        console.log('eleWidth', eleWidth)
        console.log('parentWidth', parentWidth)
        let MaxX = parentWidth - eleWidth
        if (this.rangeStatus) { // 不运行
          return false
        }
        document.onmousemove = (e) => {
          let endX = e.clientX
          this.disX = endX - startX
          if (this.disX <= 0) {
            this.disX = 0
          }
          if (this.disX >= MaxX - eleWidth) { // 减去滑块的宽度,体验效果更好
            this.disX = MaxX
          }
          ele.style.transition = '.1s all'
          ele.style.transform = 'translateX(' + this.disX + 'px)'
          document.querySelector('.special-slide-block').style.right = `calc(100% - ${this.disX + 52}px)`
          e.preventDefault()

        }
        document.onmouseup = () => {
          if (this.disX !== MaxX) {
            ele.style.transition = '.5s all'
            ele.style.transform = 'translateX(0)'
            document.querySelector('.special-slide-block').style.right = 'auto'
            // 执行成功的函数
          } else {
            this.rangeStatus = true
            if (this.status) {
              this.$parent[this.status] = true
            }
            // 执行成功的函数
            this.doVerify()
          }
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    doClickButton() {
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
      } else {
        // 执行成功的函数
        this.doVerify()
      }
    },
    // 手机验证后需要修改密码
    onUpdatePwd() {
      this.loginShow = false
      this.mobileShow = false
      this.updatePasswordShow = true
      // 密码过期修改密码
      this.updateType = 'expired'
    },
    doVerify() {
      let reqdata = {
        userCode: this.loginFormValidate.userName,
        password: this.loginFormValidate.userPassword
      }
      this.$request.post('/sso/login/checkUserNameAndPWD', reqdata).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 下一步界面：index：门户首页；mobile：手机验证；updatePwd：修改密码；remind：错误提示信息
          switch (data.nextStep) {
            case 'index':
              // 设置语言和皮肤
              this.$i18n.locale = data.languageSign
              this.$store.dispatch('doChangeSkin', data.skinColor)

              session.setObject(data.sessionId)
              session.setItem('userInfo', JSON.stringify(data))
              cookie.setCookie('token', data.sessionId)
              cookie.setCookie('userInfo', JSON.stringify(data))
              if (!window.document.location.origin.includes('hello.')) {
                this.$router.push({ name: 'home' })
              } else {
                this.$router.push({ name: 'home_old' })
              }
              break

            case 'mobile':
              if (JSON.stringify(data.mobileList) == "[]" || data.mobileList == null) {
                this.$Message.warning('用户信息缺少手机号码，无法通过短信验证码登录')
                this.verifyPass = false
                this.$refs.dragVerifyRef.reset()
                this.mobileShow = true
                this.loginShow = false
                return
              }
              session.setItem('userInfo', JSON.stringify(data))
              this.mobileShowType = 'mobile'
              this.mobileList = data.mobileList.map(k => { return { mobile: k } })
              this.mobileShow = true
              this.loginShow = false
              this.updatePasswordShow = false
              break

            case 'updatePwd':
              session.setItem('userInfo', JSON.stringify(data))
              // 首次登录，修改初始密码
              this.loginShow = false
              this.mobileShow = false
              this.updatePasswordShow = true
              this.updateType = 'initial'
              break

            default:
              this.verifyPass = false
              this.$refs.dragVerifyRef.reset()
              if (!window.document.location.origin.includes('hello.')) {
                this.rangeStatus = false
                // document.querySelector('.special-button-block').style.transform = 'translateX(0)'
                // document.querySelector('.special-slide-block').style.right = 'auto'
              }
              this.$Modal.warning({
                title: this.$t('wxts'),
                content: data.message
              })
              break
          }
        } else {
          this.verifyPass = false
          this.$refs.dragVerifyRef.reset()
          if (!window.document.location.origin.includes('hello.')) {
            this.rangeStatus = false
            // document.querySelector('.special-button-block').style.transform = 'translateX(0)'
            // document.querySelector('.special-slide-block').style.right = 'auto'
          }
        }
      })
    },
    // 切换扫码方式
    handleScan(type) {
      this.isScanActive = type
      switch (type) {
        case 'wx':
          this.doShowQRCode()
          break

        default:
          this.doShowDdQRCode()
          break
      }
    },
    // 返回登录页
    onBack(type) {
      if (type === 'mobile') {
        // 返回忘记密码页面
        this.handleFindPassword()
      } else {
        this.loginTypeShow = false
        this.loginShow = true
        this.updatePasswordShow = false
        this.mobileShow = false
        this.mobileShowType = ''
        if (!window.document.location.origin.includes('hello.')) {
          this.rangeStatus = false
          // document.querySelector('.special-button-block').style.transform = 'translateX(0)'
          // document.querySelector('.special-slide-block').style.right = 'auto'
        }
      }
    },
    // 打开忘记密码弹框
    handleFindPassword() {
      this.loginShow = false
      // this.loginFormValidate.userName = ''
      // this.loginFormValidate.userPassword = ''
      this.updatePasswordShow = false
      this.mobileShow = true
      this.mobileShowType = 'forgetPassword'
    },
    // 忘记密码点击下一步
    onForgetpwd(data) {
      this.mobileShow = false
      this.updatePasswordShow = true
      this.updateType = 'forget'
      this.forgetData = data
    },
    // 登录
    doLogin() {
      let reqdata = {
        userCode: this.loginFormValidate.userName,
        password: this.loginFormValidate.userPassword
      }
      this.$request.post('/sso/login/userLogin', reqdata).then(res => {
        const { code, data, message } = res.data
        if (code === 'OK') {
          this.userInfo = data
          if (data.message && data.message.indexOf('首次登录') !== -1) {
            // 首次登录，修改初始密码
            this.loginShow = false
            this.mobileShow = false
            this.updatePasswordShow = true
            this.updateType = 'initial'
          } else {
            // 设置语言和皮肤
            this.$i18n.locale = data.languageSign
            this.$store.dispatch('doChangeSkin', data.skinColor)

            session.setObject(data.sessionId)
            session.setItem('userInfo', JSON.stringify(data))
            cookie.setCookie('token', data.sessionId)
            cookie.setCookie('userInfo', JSON.stringify(data))
            if (!window.document.location.origin.includes('hello.')) {
              this.$router.push({ name: 'home' })
            } else {
              this.$router.push({ name: 'home_old' })
            }
            if (data.remindedMessage) {
              this.$Modal.warning({
                title: this.$t('wxts'),
                content: data.remindedMessage
              })
            }
          }
        } else if (code === 'fail') {
          if (!window.document.location.origin.includes('hello.')) {
            this.rangeStatus = false
            // document.querySelector('.special-button-block').style.transform = 'translateX(0)'
            // document.querySelector('.special-slide-block').style.right = 'auto'
          }

          this.mobileShow = false
          if (message.indexOf('验证码') !== -1) {
            this.loginShow = false
            this.updatePasswordShow = false
            this.mobileShow = true
            this.mobileShowType = 'mobile'
          }
        }
      })
    },
    // 修改密码成功
    onSuccessUpdate() {
      this.loginShow = true
      this.loginFormValidate.userName = ''
      this.loginFormValidate.userPassword = ''
      this.updatePasswordShow = false
      this.mobileShow = false
      this.forgetData = {}
    }
  }
}
</script>

<style lang="less">
body {
  overflow: hidden;
}

// .ivu-input {
//     font-size: 18px !important;
//     background-color: rgb(252, 250, 250) !important;
//     height: 18px !important;
//     line-height: 18px !important;
//   }

//   .ivu-icon-ios-eye-off-outline {
//     font-size: 18px !important;
//   }
.center-login-form-center {
  display: flex;
  justify-content: center;
}

.center-login-align {
  width: 100%;
}

.center-login-form-align {
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 460px;
  margin-top: 20px;
  padding: 100px 0;
}

.center-login-container {
  width: 100%;
  height: 100%;
  background: url('../../assets/images/login-center-bg.jpg') center center no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  ;

  .logo {
    position: absolute;
    left: 60px;
    top: 40px;

    img {
      // width: 126px;
      width: 100%;
    }
  }

  .center-login-content {
    // width: 1400px;
    width: 80%;
    height: 100vh;
    position: relative;
    // margin: auto;
    // left: 50%;
    // margin-left: -700px;
    display: flex;
    align-items: center;
    justify-content: center;

    .center-login-scan {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 54px;
      height: 54px;
      cursor: pointer;

      .icon {
        color: #C8291D;
        font-size: 54px;
      }
    }

    .scan-tag {
      display: inline-block;
      position: absolute;
      right: 20px;
      top: 16px;
      width: 68px;
      height: 68px;
      transform: rotate(45deg);
      background-color: transparent;
    }

    .center-login-box {
      position: absolute;
      // width: 634px;
      width: 40%;
      // height: 640px;
      // margin: 0 auto;
      background-color: rgba(255, 255, 255, .4);
      border-radius: 6px;
      padding: 0 88px;
      border: 1px solid;
      border-color: #00A9FF;

      .center-login-title {
        // position: absolute;
        // left: 0;
        // right: 0;
        text-align: center;
        // top: -86px;
        font-size: 36px;
        margin-top: 55px;
        color: #FFFFFF;
        line-height: 1;
      }

      .center-login-tab {
        padding: 32px 40px;
        padding-top: 0;
        padding-bottom: 45px;
        color: #FFFFFF;
        text-align: center;

        span {
          // flex: 1;
          font-size: 20px;
          text-align: center;
          position: relative;
          cursor: pointer;

          &:first-child {
            margin-right: 72px;
          }

          &[active] {
            font-size: 26px;

            // font-weight: bold;
            .active {
              display: inline-block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 104px;
              height: 12px;
              background-color: blue;
              opacity: .5;
            }
          }
        }
      }

      .center-login-form {
        .center-login-form-title {
          display: flex;
          margin-top: 48px;
          margin-bottom: 32px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 37px;

          .icon {
            flex: 0 0 46px;
            text-align: center;
            line-height: 37px;
            color: #00A7FF;
            cursor: pointer;
            // margin-right: 24px;
          }

          span {
            flex: 1;
            padding-left: 12px;
          }

          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
          }
        }

        .center-login-form-input {
          width: 100%;
          background: rgba(255, 255, 255, .2);
          border: 1px solid;
          border-color: #073DBE;
          border-radius: 4px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          height: 54px;
          margin-bottom: 24px;
          padding-right: 16px;

          .input-icon {
            // flex: 0 0 52px;
            color: #073DBE;
            padding: 0 16px;
            box-sizing: border-box;
          }

          .input-self {
            flex: 1;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;
            min-width: 100px;

            &.ivu-input-wrapper {
              input {
                font-size: 18px;
                background-color: transparent;
                padding: 0;
                color: rgb(66, 64, 64);

                .ivu-icon-ios-eye-off-outline {
                  font-size: 18px;
                }

                &::placeholder {
                  color: #999;
                }
              }
            }
          }
        }

        .forgetPwd {
          display: flex;
          justify-content: space-between;
          line-height: 1;

          .item {
            cursor: pointer;
            font-size: 18px;
            font-weight: 400;
          }
        }

        .forget-password {
          text-align: right;
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 1;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .center-login-button {
          box-shadow: none;
          background-color: #00A8FE;
          width: 100%;
          height: 54px;
          border-radius: 4px;
          line-height: 54px;
          font-size: 18px;
          color: #FFFFFF;
          margin-bottom: 70px;
          position: relative;
          cursor: pointer;
        }

        .special-button {
          height: 54px;
          overflow: hidden;
          margin-bottom: 70px;
          // 输入框边框颜色
          background-color: #00A8FE;
          position: relative;
          transition: 1s all;
          user-select: none;
          // 字体颜色
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;

          &.success {
            background-color: #073DBE;
            color: #fff;
          }

          .special-button-block {
            position: absolute;
            z-index: 99;
            padding: 4px;
            top: 0;
            left: 0;
            bottom: 0;
            width: 52px;
            color: #fff;
            background-color: #073DBE;
            background-clip: content-box;
            cursor: pointer;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;

            &::after {
              content: '>>';
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }
    }

    .center-login-link {
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      bottom: 80px;
      left: 0;
      right: 0;
      text-align: center;
      cursor: pointer;
    }

    .center-login-footer {
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
      bottom: 40px;
      text-align: center;
      font-size: 14px;
      color: #999999;
    }

    .center-login-qrcode {
      // width: 405px;
      // height: 435px;
      // margin: 32px auto;
      // margin-top: 0;
      padding: 0.5rem 0;
      background-color: transparent;
      background-clip: content-box;
      display: flex;
      align-items: center;
      justify-content: center;
      // padding: 8px;
      border-radius: 4px;
      position: relative;

      // overflow: hidden;
      #QRCode {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        border-radius: 4px;
        overflow: hidden;

        iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0px;
          left: 0px;
        }
      }

      #QRCodedd {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        text-align: center;

        iframe {
          background: #fff;
        }
      }

      &[expired] {
        background-color: #FFFFFF;
        opacity: .8;
      }

      .expired-code {
        p {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .refresh-code {
          margin: 0 auto;
          margin-top: 8px;
          width: 98px;
          height: 31px;
          line-height: 31px;
          font-size: 13px;
          color: #FFFFFF;
          background: #00A8FE;
        }
      }
    }

    .qrcode-type {
      position: absolute;
      bottom: -28px;
      text-align: center;
      font-size: 18px;
      color: #666666;
      line-height: 25px;
      cursor: pointer;
      left: 0;
      margin-bottom: 40px;
      width: 634px;

      span {
        &[active] {
          color: #FFFFFF;
        }
      }
    }
  }

  .center-login-content2 {
    width: 1400px;
    height: 100vh;
    position: relative;
    left: 50%;
    margin-left: -700px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      position: absolute;
      left: 60px;
      top: 40px;

      img {
        width: 126px;
      }
    }

    .center-login-box {
      background: transparent;
      padding: 0 24px;
      border-radius: 10px;
      text-align: center;
      position: absolute;
      width: 1124px;
      height: 615px;
      margin: 0 auto;

      .center-login-title {
        margin-top: 4vh;
        text-align: center;
        font-size: 50px;
        color: #FFFFFF;
        line-height: 1;
      }

      .center-login-tab {
        padding: 32px 40px;
        padding-top: 0px;
        padding-bottom: 45px;
        color: #FFFFFF;
        text-align: center;

        span {
          // flex: 1;
          font-size: 20px;
          text-align: center;
          position: relative;
          cursor: pointer;

          &:first-child {
            margin-right: 72px;
          }

          &[active] {
            font-size: 24px;

            // font-weight: bold;
            .active {
              display: inline-block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 104px;
              height: 12px;
              background-color: blue;
              opacity: .5;
            }
          }
        }
      }

      .center-login-form {
        position: relative;

        .center-login-form-center {
          display: flex;
          justify-content: center;
        }

        // overflow: hidden;
        .center-login-form-title {
          display: flex;
          margin-top: 48px;
          margin-bottom: 32px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 37px;

          .icon {
            flex: 0 0 46px;
            text-align: left;
            line-height: 37px;
            color: #00A7FF;
            cursor: pointer;
          }

          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
          }
        }

        .center-login-form-input {
          position: relative;
          width: 260px;
          float: left;
          background: rgba(255, 255, 255, .2);
          border: 1px solid;
          border-color: #073DBE;
          border-radius: 26px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          height: 44px;
          margin-bottom: 24px;
          padding-right: 16px;
          margin-right: 12px;

          .input-icon {
            color: #073DBE;
            padding: 0 16px;
          }

          .input-self {
            flex: 1;
            max-width: 200px;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;
            min-width: 100px;
          }
        }

        .forget-password {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 18px;
          text-decoration: underline;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 1;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .center-login-button {
          float: left;
          box-shadow: none;
          background-color: #00A8FE;
          width: 260px;
          height: 44px;
          border-radius: 26px;
          line-height: 44px;
          font-size: 18px;
          color: #FFFFFF;
          margin-bottom: 70px;
          position: relative;
          cursor: pointer;
        }

        .center-login-range {
          width: 260px;
          float: left;
        }

        .special-button {
          overflow: hidden;
          margin-bottom: 70px;
          // 输入框边框颜色
          background-color: #00A8FE;
          border-radius: 26px;
          position: relative;
          transition: 1s all;
          user-select: none;
          // 字体颜色
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 44px;

          &.success {
            background-color: #073DBE;
            color: #fff;
          }

          .special-button-block {
            position: absolute;
            z-index: 99;
            padding: 4px;
            top: 0;
            left: 0;
            bottom: 0;
            width: 52px;
            border-radius: 26px;
            color: #fff;
            background-color: #073DBE;
            background-clip: content-box;
            cursor: pointer;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;

            &::after {
              content: '>>';
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }

      .center-login-form-margin {
        margin: 60px auto;
      }
    }

    .center-login-link {
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      bottom: 80px;
      left: 0;
      right: 0;
      text-align: center;
      cursor: pointer;
    }

    .center-login-footer {
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
      bottom: 40px;
      text-align: center;
      font-size: 14px;
      color: #999999;
    }

    .center-login-qrcode {
      width: 320px;
      height: 320px;
      margin: 32px auto;
      margin-top: 0;
      background-color: #fff;
      background-clip: content-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      border-radius: 4px;
      position: relative;
      overflow: hidden;

      #QRCode {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        border-radius: 4px;
        overflow: hidden;

        iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0px;
          left: 0px;
        }
      }

      #QRCodedd {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;

        iframe {
          background: #fff;
        }
      }

      &[expired] {
        background-color: #FFFFFF;
        opacity: .8;
      }

      .expired-code {
        p {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .refresh-code {
          margin: 0 auto;
          margin-top: 8px;
          width: 98px;
          height: 31px;
          line-height: 31px;
          font-size: 13px;
          color: #FFFFFF;
          background: #00A8FE;
        }
      }
    }

    .qrcode-type {
      position: absolute;
      bottom: 0;
      text-align: center;
      transform: translateX(50%);
      font-size: 18px;
      color: #666666;
      line-height: 25px;
      cursor: pointer;
      margin-bottom: 40px;

      span {
        &[active] {
          color: #FFFFFF;
        }
      }
    }
  }
}

.right-login-container2 {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: url('../../assets/images/login-right-bg.png') center right no-repeat;
  background-size: cover;

  .logo {
    position: absolute;
    left: 60px;
    top: 40px;

    img {
      width: 126px;
    }
  }

  .right-login-content-blur {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    // filter: blur(6px);
    // background-color: #d0d4d8;
    background-color: #B6B9C2;
    opacity: 0.5;
    background-repeat: no-repeat;
    background-position: center right;
    background-attachment: fixed;
    // background-size: cover;
  }

  .right-login-content {
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 684px;
    display: flex;
    align-items: center;
    justify-content: center;

    .right-login-box {
      position: absolute;
      width: 450px;
      min-height: 70vh;
      // right: 104px;
      background-color: #fff;
      border-radius: 6px;
      padding: 0 32px;
      border: 1px solid;
      border-color: #FFFFFF;

      .right-login-scan {
        position: absolute;
        right: 0px;
        top: 0px;
        width: 54px;
        height: 54px;
        cursor: pointer;

        .icon {
          color: #C8291D;
          font-size: 54px;
        }
      }

      .scan-tag {
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 16px;
        width: 68px;
        height: 68px;
        transform: rotate(45deg);
        background-color: #FFFFFF;
      }

      .right-login-title {
        margin-top: 55px;
        text-align: center;
        font-size: 36px;
        // font-weight: 800;
        color: #333333;
        line-height: 1;
      }

      .right-login-form {
        .right-login-form-title {
          display: flex;
          margin-top: 48px;
          margin-bottom: 16px;
          font-size: 20px;
          color: #333333;
          align-items: center;

          .icon {
            flex: 0 0 46px;
            text-align: center;
            cursor: pointer;
            margin-top: -2px;
          }

          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
            color: #999999;
            vertical-align: middle;
          }
        }

        .right-login-form-input {
          width: 100%;
          background-color: #FCFCFC;
          border: 1px solid;
          border-color: #dddddd;
          border-radius: 4px;
          display: flex;
          align-items: center;
          height: 54px;
          margin-bottom: 24px;
          padding-right: 16px;

          .input-icon {
            color: #666666;
            padding: 0 16px;

            .icon {
              font-size: 20px;
            }

            .ivu-icon {
              font-weight: bold;
              font-size: 24px !important;
            }
          }

          .input-self {
            flex: 1;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 18px;
            line-height: 28px;
            color: #333333;
            min-width: 100px;

            &::-webkit-input-placeholder {
              color: #999;
            }

            &::-moz-placeholder {
              color: #999;
            }

            .default {
              color: #7F7F7F;
            }

            .ivu-input-suffix {
              font-size: 18px !important;
              color: rgb(66, 64, 64) !important;
            }

            .ivu-input {
              font-size: 18px !important;
              padding: 0 !important;
              color: rgb(66, 64, 64) !important;
            }
          }
        }

        .forgetPwd {
          display: flex;
          justify-content: space-between;
          line-height: 1;

          .item {
            cursor: pointer;
            font-size: 18px;
            font-weight: 400;
          }
        }

        .forget-password {
          text-align: right;
          font-size: 16px;
          font-weight: 400;
          color: #C8291D;
          line-height: 1;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .right-login-button {
          box-shadow: none;
          background-color: #C8291D;
          width: 100%;
          height: 54px;
          border-radius: 4px;
          line-height: 54px;
          font-size: 18px;
          color: #FFFFFF;
          cursor: pointer;
        }

        .special-button {
          margin-bottom: 70px;
          // 输入框边框颜色
          background-color: #C8291D;
          position: relative;
          transition: 1s all;
          user-select: none;
          border-radius: 4px;
          // 字体颜色
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 54px;
          overflow: hidden;

          &.success {
            background-color: #dddddd;
            color: #fff;
          }

          .special-button-block {
            position: absolute;
            z-index: 99;
            padding: 4px;
            top: 0;
            left: 0;
            bottom: 0;
            width: 52px;
            border-radius: 6px;
            color: #fff;
            background-color: #dddddd;
            background-clip: content-box;
            cursor: pointer;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;

            &::after {
              content: '>>';
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }
    }

    .right-login-box-padding {
      padding: 0;
    }
  }

  .right-login-link {
    font-size: 18px;
    color: #C8291D;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    text-align: center;
    cursor: pointer;
  }

  .right-login-footer {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 40px;
    text-align: center;
    font-size: 14px;
    color: #999999;
  }

  .right-login-qrcode {
    // width: 405px;
    height: 435px;
    margin: 12px auto;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    #QRCode {
      height: 100%;
      width: 100%;
      margin: 0 auto;
      position: relative;

      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
      }
    }

    #QRCodedd {
      height: 100%;
      width: 100%;
      margin: 0 auto;
      position: relative;
      text-align: center;
    }

    &[expired] {
      background-color: #FFFFFF;
      opacity: .8;
    }

    .expired-code {
      p {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .refresh-code {
        margin: 0 auto;
        margin-top: 8px;
        width: 98px;
        height: 31px;
        line-height: 31px;
        font-size: 13px;
        color: #FFFFFF;
        background: #C8291D;
      }
    }
  }

  .qrcode-type {
    text-align: center;
    font-size: 18px;
    color: #666666;
    line-height: 25px;
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 24px;

    span {
      &[active] {
        color: #C12522;
      }
    }
  }
}

.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .notice-title {
    text-align: center;
    padding-bottom: 10px;
  }

  .notice-date {
    font-size: 14px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px dashed #000;
    margin-bottom: 10px;
  }

  .ivu-modal {
    top: 0;
  }

  .ivu-modal-body {
    padding: 0;
    padding-top: 16px;
  }

  .modal-title {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
  }

  .search-btn {
    display: flex;
    justify-content: space-between;

    .btn-left {
      display: flex;

      .btn-item {
        width: 80px;
        height: 30px;
        border-radius: 5px;
        padding-top: 5px;
        margin: 0 10px;
        text-align: center;
        cursor: pointer;
      }

      .btnActive {
        border-bottom: 3px;
        border-bottom-style: solid;
        color: #fff;
      }
    }

    .btn-right {
      margin-right: 50px;
    }
  }

  .btn-dc {
    margin: 0 20px 10px 10px;
    text-align: right;
  }

  .modal-content {
    display: flex;
    // justify-content: center;
    // align-items: center;
    flex-wrap: wrap;
    // height: 520px;
    max-height: 520px;
    min-height: 130px;
    overflow-y: auto;

    &-center {
      justify-content: center;
    }

    .items {
      flex: 0 0 20%;
      position: relative;
      box-sizing: border-box;
      padding: 12px;
      text-align: center;

      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-bottom: 8px;
      }

      .name {
        text-align: center;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        height: 44px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;

        // white-space: nowrap;
        &[active] {
          color: #C8291D;
        }
      }

      .icon-normal {
        width: 38px;
        height: 38px;
        margin: 22px;
      }

      .back-name {
        line-height: 22px;
        height: auto;
      }

      .bj-light {
        position: absolute;
        top: 22px;
        left: 20px;
        width: 64px;
        height: 64px;
        background: #C8291D;
        border-radius: 8px;
        opacity: 0.5;
      }

      .checked {
        position: absolute;
        right: 26%;
        top: 12px;
        border: 2px solid #FFFFFF;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #C8291D;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon {
          color: #FFFFFF;
          font-size: 16px;
        }
      }
    }

    .skin-box {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }

    .certificatesList {
      width: 100%;
      padding: 1% 3%;
      display: flex;
      border-bottom: 1px solid #eee;
      justify-content: space-between;

      .item:first-child {
        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        .item-index {
          display: inline-block;
          padding: 0px 6px;
          height: 21px;
          text-align: center;
          color: #fff;
          border-radius: 50%;
          margin-right: 30px;
        }
      }

      .item:last-child {
        border-lef: 2px solid red;
      }
    }

    .certificatesList:hover {
      background-color: #eee;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;

    .button {
      width: 150px;
    }
  }
}

@media screen and (max-width: 820px) and (min-width: 320px) {


  .center-login-content {
    .center-login-box {
      width: 100% !important;

      .center-login-tab {
        padding-bottom: 160px !important;
      }

      .center-login-title {
        font-size: 60px !important;
      }

      .center-login-scan {
        font-size: 0.2rem;
      }

      .center-login-form {
        .center-login-align {
          .center-login-form-input {
            height: 120px !important;
            font-size: 40px !important;
            margin-bottom: 40px !important;

            .input-self {
              // height: 0.4rem;
              line-height: 120px !important;
              font-size: 40px !important;

              .ivu-select-dropdown-list {
                height: 40px !important;
              }
            }
          }

          .forgetPwd {
            .item {
              font-size: 30px !important;

              .forget-password {
                font-size: 30px !important;
              }
            }
          }
        }

        .center-login-form-title {
          i {
            font-size: 80px !important;
          }

          span {
            font-size: 40px !important;
          }
        }

        .center-login-form-input {
          height: 120px !important;
          font-size: 40px !important;
          margin-bottom: 40px !important;

          .input-self {
            // height: 0.4rem;
            line-height: 120px !important;
            font-size: 40px !important;

            &.ivu-input-wrapper {
              position: relative;
              margin-right: 20px;

              input {
                font-size: 40px !important;
                background-color: transparent !important;
                height: 120px !important;
                line-height: 120px !important;
              }

              input::placeholder {
                color: #777 !important;
              }

              .ivu-icon-ios-eye-off-outline {
                font-size: 40px !important;
              }
            }
          }
        }

        button {
          height: 120px !important;
          font-size: 40px !important;
        }

        .qrcode-type {
          position: initial;
          font-size: 50px !important;
          margin: auto;
          padding-bottom: 80px;
        }
      }

      .mobile-style1 {
        .center-login-form-title {
          font-size: 0.2rem !important;

          .icon {
            font-size: 0.2rem !important;
          }
        }

        .center-login-form-input {
          height: 120px !important;
          font-size: 40px !important;
          margin-bottom: 40px !important;

          .input-self {
            // height: 0.4rem;
            // line-height: 0.4rem;
            position: relative;
            font-size: 40px !important;

            .ivu-select-placeholder {
              font-size: 40px !important;
              overflow: initial;
            }

            .ivu-select-selection {
              span {
                font-size: 40px !important;
                height: 40px !important;
                line-height: 40px !important;
              }

              i {
                font-size: 40px !important;
              }
            }

            .ivu-select-dropdown {
              top: 0.4rem !important;
              left: 0 !important;

              ul {
                li {
                  font-size: 40px !important;
                }
              }
            }

          }

          .verify-code {
            font-size: 40px !important;
          }
        }

        .center-login-button {
          font-size: 40px !important;
          height: 0.6rem !important;
        }
      }
    }
  }

  .ivu-modal {
    width: 80% !important;

    .ivu-modal-content {
      .ivu-modal-close {
        font-size: 30px;

        .ivu-icon {
          font-size: 30px;
        }
      }

      .ivu-modal-header {
        line-height: initial;

        .modal-title {
          font-size: 30px;
          height: 40px;
          line-height: 40px;
        }
      }

      .ivu-modal-body {
        .modal-content {
          .items {
            .checked {
              top: 0;
              right: 8%;
              width: 0.3rem;
              height: 0.3rem;

              .icon {
                font-size: 0.2rem;
              }
            }

            img {
              width: 1rem;
              height: 1rem;
            }

            .name {
              font-size: 0.14rem;
              height: 0.2rem;
              line-height: 0.2rem;
            }
          }
        }
      }

      .ivu-modal-footer {
        padding: 0.2rem 0;

        .modal-footer {
          button {
            width: 2rem;
            height: 0.5rem;
            font-size: 0.22rem;
            border-radius: 0.5rem;
          }
        }
      }
    }
  }

  .right-login-container2 {
    .right-login-content {
      width: 80% !important;

      .right-login-box {
        width: 80% !important;

        .center-login-tab {
          padding-bottom: 160px !important;
        }

        .right-login-title {
          font-size: 60px !important;
        }

        .right-login-scan {
          font-size: 0.2rem;
        }

        .right-login-form {
          .right-login-form-title {
            font-size: 40px !important;
          }

          .right-login-form-input {
            height: 120px !important;
            font-size: 40px !important;
            margin-bottom: 40px !important;
            position: relative;

            .input-icon {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 120px !important;
              line-height: 120px !important;

              svg {
                font-size: 40px !important;
              }

              .ivu-icon {
                font-size: 40px !important;
              }
            }

            .input-self {
              // height: 0.4rem;
              // line-height: 0.4rem;
              font-size: 40px !important;

              .ivu-select-selection {
                span {
                  font-size: 40px !important;
                  height: 40px !important;
                  line-height: 40px !important;
                }
              }

              .ivu-select-dropdown {
                top: 0.56rem !important;
                left: 0.48rem !important;
                height: 40PX !important;

                ul {
                  li {
                    font-size: 40px !important;
                  }
                }
              }

              &.ivu-input-wrapper {
                position: relative;
                margin-right: 20px;

                input {
                  font-size: 40px !important;
                  background-color: transparent !important;
                  height: 40px !important;
                  line-height: 40px !important;
                }

                input::placeholder {
                  color: #999;
                }

                .ivu-icon-ios-eye-off-outline {
                  font-size: 40px !important;
                }
              }
            }

            .verify-code {
              font-size: 40px !important;
            }

          }

          button {
            height: 40PX !important;
            font-size: 40px !important;
          }

          .forgetPwd {
            .item {
              font-size: 30px !important;

              .forget-password {
                font-size: 30px !important;
              }
            }
          }

          .right-login-qrcode {
            width: 100% !important;
            height: inherit;
            padding-top: 40px;

            #QRCodedd {
              height: auto !important;
            }
          }

          .qrcode-type {
            font-size: 30px !important;
          }
        }

        .mobile-style1 {
          background-color: #00A7FF;

          .center-login-form-title {
            font-size: 0.22rem !important;
            padding: 20px 0;
            display: flex;
            // justify-content: center;
            align-items: center;

            .icon {
              font-size: 0.4rem !important;
              color: #000 !important;
            }
          }

          .center-login-form-input {
            height: 120px !important;
            font-size: 40px !important;
            margin-bottom: 40px !important;

            .input-self {
              // height: 0.4rem;
              // line-height: 0.4rem;
              font-size: 40px !important;

              .ivu-select-placeholder {
                font-size: 40px !important;
                overflow: initial;
                border: none;
              }

            }

            .verify-code {
              font-size: 40px !important;
            }
          }

          .right-login-button {
            font-size: 40px !important;
            height: 0.6rem !important;
          }
        }
      }

      .right-login-link {
        font-size: 40px !important;
        bottom: 280px;
        z-index: 999;
      }
    }

    .right-login-footer {
      font-size: 40px !important;
    }
  }
}
</style>
